module.exports = __webpack_public_path__ + "img/logo2.f85958b0.png";